import axios from "axios"
import * as env from "../constants/env"


/* List Game Tables */
export const tables = (data) => {
    const uri = `${env.startpoint}game/tables`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Resolve One Round — a table named by its uid, its slug or its id, a round by its id, its round id or its number */
export const round = (data) => {
    const uri = `${env.startpoint}game/round`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Create */
export const create = (data) => {
    const uri = `${env.startpoint}game/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Game Catalogue — the types and the games a table can be created from */
export const catalog = () => {
    const uri = `${env.startpoint}game/catalog`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Create Game Type — superadmin only */
export const createType = (data) => {
    const uri = `${env.startpoint}game/catalog-type`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Create Catalogue Game — superadmin only */
export const createGame = (data) => {
    const uri = `${env.startpoint}game/catalog-game`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Edit Game Type — superadmin only */
export const editType = (data) => {
    const uri = `${env.startpoint}game/catalog-type-edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Remove Game Type — superadmin only */
export const removeType = (data) => {
    const uri = `${env.startpoint}game/catalog-type-remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Edit Catalogue Game — superadmin only */
export const editGame = (data) => {
    const uri = `${env.startpoint}game/catalog-game-edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Remove Catalogue Game — superadmin only */
export const removeGame = (data) => {
    const uri = `${env.startpoint}game/catalog-game-remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Toggle saved game (общая сохранёнка): { gameID, postfix } -> { saved } */
export const saveGame = (data) => {
    const uri = `${env.startpoint}game/save`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

